import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CpdMessage from './CpdMessage';
import GeneratedFileList from './GeneratedFileList';
export const IssueMessage = (props) => {
    const { tool, message, ruleId, options, handleScrollToLine } = props;
    const { t } = useTranslation();
    if (['cpd', 'phpcpd', 'jscpd'].includes(tool)) {
        return _jsx(CpdMessage, { message: message, handleScrollToLine: handleScrollToLine });
    }
    else if (tool === t('siteName').toLowerCase() && ruleId === 'GeneratedFiles') {
        return _jsx(GeneratedFileList, { options: options });
    }
    return _jsx("pre", { children: message });
};
